import { useRef, useState } from "react";
import { Mic, Square, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function VoiceInput({ onText }) {
  const [state, setState] = useState("idle");
  const recRef = useRef(null);
  const chunks = useRef([]);

  const startRec = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const rec = new MediaRecorder(stream);
      chunks.current = [];
      rec.ondataavailable = (e) => e.data.size && chunks.current.push(e.data);
      rec.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("busy");
        const blob = new Blob(chunks.current, { type: rec.mimeType || "audio/webm" });
        const fd = new FormData();
        fd.append("file", blob, "voice.webm");
        try {
          const { data } = await api.post("/transcribe", fd);
          if (data.text) onText(data.text);
        } catch {
          toast.error("Couldn't hear that clearly. Try once more?");
        }
        setState("idle");
      };
      rec.start();
      recRef.current = rec;
      setState("rec");
    } catch {
      toast.error("Microphone access is needed for voice input.");
    }
  };

  const stopRec = () => recRef.current?.state === "recording" && recRef.current.stop();

  return (
    <button
      type="button"
      data-testid="voice-input-button"
      onClick={state === "rec" ? stopRec : state === "idle" ? startRec : undefined}
      className={`relative h-14 w-14 rounded-full flex items-center justify-center border transition-colors duration-200 ${state === "rec" ? "bg-neutral-900 text-white border-neutral-900 pulse-ring" : "border-neutral-300 hover:border-neutral-900"}`}
      aria-label={state === "rec" ? "Stop recording" : "Record voice"}
    >
      {state === "busy" ? <Loader2 size={20} className="animate-spin" /> : state === "rec" ? <Square size={16} fill="currentColor" /> : <Mic size={20} />}
    </button>
  );
}
